import React, { Component } from "react";
import { connect } from "react-redux";
import { setAlert } from "../../../../actions/alertActions";
import Modal from "react-bootstrap/Modal";
import ConfirmationModal from "../editUser/ConfirmationModal";
import EditUserForm from "../editUser/EditUserForm";
import axios from "axios";
import { I18n } from "react-redux-i18n";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";

class EditModelUsers extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    this.state = {
      name: user?.name || "",
      email: user?.email || "",
      phone: user ? `${user.internationalPrefix}${user.mobile}` : "",
      phonePrefix: user?.internationalPrefix || "",
      mobile: user?.mobile || "",
      country: user?.internationalPrefix === "+351" ? "pt" : null,
      validated: false,
      showConfirmationModal: false,
      confirmationMessage: "",
      cancelButtonText: I18n.t("AddStopToRouteOverlay_cancelButton"),
      confirmButtonText: I18n.t("general_save"),
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handlePhoneChange = (value, country) => {
    const countryCode = country.countryCode;
    const dialCode = country.dialCode;

    const newPhone =
      country.countryCode === this.state.country ? value : dialCode;

    const newMobile =
      country.countryCode === this.state.country
        ? value.replace(dialCode, "")
        : "";

    this.setState({
      phone: newPhone,
      mobile: newMobile,
      phonePrefix: `+${dialCode}`,
      country: countryCode,
    });
  };

  isEmailValid = () => {
    const { email } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  isNameValid = () => {
    const { name } = this.state;
    const nameRegex = /^(?=.{1,100}$)[\p{L}\s.'-]+$/u;
    return nameRegex.test(name);
  };

  isPhoneNumberValid = () => {
    const { phone } = this.state;
    let number = phone;

    if (number.includes("+")) {
      number = phone.replace("+", "");
    }
    const isValidNumberInternational = isValidPhoneNumber(`+${number}`);

    return isValidNumberInternational;
  };

  handleOnSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const isValid =
      form.checkValidity() &&
      this.isEmailValid() &&
      this.isPhoneNumberValid() &&
      this.isNameValid();

    this.setState({ validated: true, formValid: isValid });

    if (!isValid) {
      event.stopPropagation();
      if (!this.isEmailValid()) {
        this.props.setAlert(
          I18n.t("myChargersNewCharger_invalidNotificationEmail"),
          "danger"
        );
      } else if (!this.isPhoneNumberValid()) {
        this.props.setAlert(I18n.t("editPhone_invalidPhone_error"), "danger");
      } else if (!this.isNameValid()) {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyName_alert"),
          "danger"
        );
      } else {
        this.props.setAlert(I18n.t("manageUsers_warningMessageForm"), "danger");
      }
    } else {
      this.toggleConfirmationModal(
        true,
        I18n.t("manageUsers_messageSaveEditUser"),
        I18n.t("general_no"),
        I18n.t("general_yes")
      );
    }
  };

  toggleConfirmationModal = (
    show,
    message,
    cancelButtonText,
    confirmButtonText
  ) => {
    this.setState({
      showConfirmationModal: show,
      confirmationMessage: message,
      cancelButtonText: cancelButtonText,
      confirmButtonText: confirmButtonText,
    });
  };

  handleCloseModal = () => {
    const { name, email, mobile, phonePrefix } = this.state;
    const { user } = this.props;

    if (
      name !== user.name ||
      email !== user.email ||
      mobile !== user.mobile ||
      phonePrefix !== user.internationalPrefix
    ) {
      this.toggleConfirmationModal(
        true,
        I18n.t("manageUsers_messageCloseEditUser"),
        I18n.t("general_no"),
        I18n.t("general_yes")
      );
    } else {
      this.props.onHide();
    }
  };

  handleConfirmation = (confirmed) => {
    if (confirmed) {
      const isValid =
        this.isEmailValid() && this.isPhoneNumberValid() && this.isNameValid();

      if (!isValid) {
        if (!this.isEmailValid()) {
          this.props.setAlert(
            I18n.t("myChargersNewCharger_invalidNotificationEmail"),
            "danger"
          );
        } else if (!this.isPhoneNumberValid()) {
          this.props.setAlert(I18n.t("editPhone_invalidPhone_error"), "danger");
        } else if (!this.isNameValid()) {
          this.props.setAlert(
            I18n.t("backOffice_network_request_verifyName_alert"),
            "danger"
          );
        } else {
          this.props.setAlert(
            I18n.t("manageUsers_warningMessageForm"),
            "danger"
          );
        }
      } else {
        const patch = {
          name: this.state.name,
          email: this.state.email,
          mobile: this.state.mobile,
          internationalPrefix: this.state.phonePrefix,
          username:
            this.props.clientName === "EVIO"
              ? this.state.mobile
              : this.state.email,
        };

        axios
          .patch(`/api/private/users/${this.props.user._id}`, patch)
          .then((res) => {
            if (res.status === 200) {
              this.props.fetchContracts();
              this.props.setAlert(
                I18n.t("manageUsers_editUser_success"),
                "primary"
              );
              this.props.onHide();
            }
          })
          .catch((err) =>
            this.props.setAlert(
              I18n.t(err?.response?.data?.code || "general_error"),
              "danger"
            )
          );
      }
    } else {
      this.props.onHide();
    }

    this.setState({ showConfirmationModal: false });
  };

  render() {
    console.log(this.isPhoneNumberValid(), "teste");
    return (
      <>
        <Modal
          id="editUsers"
          show={this.props.show}
          onHide={this.handleCloseModal}
          centered
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{I18n.t("manageUsers_editUser")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditUserForm
              validated={this.state.validated}
              handleOnSubmit={this.handleOnSubmit}
              name={this.state.name}
              email={this.state.email}
              handleInputChange={this.handleInputChange}
              phone={this.state.phone}
              handlePhoneChange={this.handlePhoneChange}
              country={this.state.country}
              isEmailValid={this.isEmailValid}
              isNameValid={this.isNameValid}
              isPhoneNumberValid={this.isPhoneNumberValid}
            />
          </Modal.Body>
          <Modal.Footer>
            <button
              type="submit"
              form="edit-user-form"
              disabled={
                !this.isEmailValid() ||
                !this.isNameValid() ||
                !this.isPhoneNumberValid() ||
                (this.state.name === this.props.user.name &&
                  this.state.email === this.props.user.email &&
                  this.state.mobile === this.props.user.mobile &&
                  this.state.phonePrefix ===
                    this.props.user.internationalPrefix)
              }
            >
              {I18n.t("backOffice_network_forms_submit_bt")}
            </button>
          </Modal.Footer>
        </Modal>
        {this.state.showConfirmationModal && (
          <ConfirmationModal
            show={this.state.showConfirmationModal}
            onHide={() => this.props.onHide()}
            onConfirm={() => this.handleConfirmation(true)}
            onCancel={() => this.handleConfirmation(false)}
            title="Confirmation"
            message={this.state.confirmationMessage}
            cancelButtonText={this.state.cancelButtonText}
            confirmButtonText={this.state.confirmButtonText}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  clientName: state.account.accountData.clientName,
});

export default connect(mapStateToProps, { setAlert })(EditModelUsers);
